import React, { useEffect, useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getOpenSetup,
  OPEN_SETUP_ACTIONS,
  setOpenSetupConfig,
  saveRegistrationSteps,
  saveOpenPersonTypes,
  setRegStepIndex,
  saveIRTFProviderSetup,
  getRelations
} from 'actions/protocols/opensetup';
import { getPsrs } from 'actions/protocols/psrs';
import { bindLogger } from 'helpers/BindLogger';
import {
  createLoadingSelector,
  createErrorMessageSelector,
  ProtocolIdSelector,
  ProtocolNumSelector,
  lSelectorGetProtDetails,
  eSelectorGetProtDetails
} from 'selectors';
import { Grid } from '@material-ui/core';
import _ from 'lodash';
import {
  CanUserAccessOPENSetup,
  CanUserEditMisc,
  CanUserViewOPENSetupConfig,
  CanUserEditOPENSteps,
  CanUserViewOPENSteps,
  CanUserDelOPENSteps,
  CanUserViewOPENProvider,
  CanUserEditOPENProvider,
  CanUserViewOPENRelations,
  CanUserEditOPENRelations,
  CanUserViewOPENPerson,
  CanUserEditOPENPerson,
  CanUserDelOPENPerson
} from 'appconstants/Permission';
import { RenderControl } from 'components/RenderHelpers';
import { withAppContext } from '@ctsu/loader';
import {
  RegSteps,
  OpenInves,
  ProtocolRelations,
  OPENITRFProvideSetup,
  Miscellaneous,
  GroupOpenPerson,
  OpenSetupConfigs
} from './components';

const lOPENSetupSelector = createLoadingSelector([
  OPEN_SETUP_ACTIONS.GET_OPENSETUP
]);
const eOPENSetupSelector = createErrorMessageSelector([
  OPEN_SETUP_ACTIONS.GET_OPENSETUP
]);

const lRelationSelector = createLoadingSelector([
  OPEN_SETUP_ACTIONS.GET_RELATIONS
]);

const eRelationSelector = createErrorMessageSelector([
  OPEN_SETUP_ACTIONS.GET_RELATIONS
]);

const OpenSetupComp = props => {
  const {
    protocolNumber,
    protocolId,
    context,
    regStepInd,
    psrs,
    onGetPsr,
    onGetOpenSetupData,
    openSetupInfo,
    onSetOpenSetupConfig,
    onSaveRegSteps,
    onSaveOpenSetupPersonTypes,
    onSetRegStepIndex,
    onSaveIRTFProviderSetup,
    onGetRelations,
    relations,
    isLoadingPrtDetails,
    iserrorPrtDetails,
    isloadingOPENSetup,
    iserrorOPENSetup,
    isloadingRelation,
    iserrorRelation
  } = props;
  const { protocolLogistics, openProtPerTypes } = openSetupInfo;
  const [isDisableEditButton, setIsDisableEditButton] = useState(false);

  useEffect(() => {
    if (!_.isEmpty(protocolNumber)) {
      bindLogger(onGetOpenSetupData, context)(protocolNumber);
      bindLogger(onGetPsr, context)(protocolNumber);
      bindLogger(onGetRelations, context)(protocolNumber);
    }
  }, [protocolNumber, onGetOpenSetupData, context, onGetPsr, onGetRelations]);

  const ClickedRow = (row, index) => {
    onSetRegStepIndex(index);
  };

  return (
    <RenderControl
      isLoading={isLoadingPrtDetails}
      iserror={iserrorPrtDetails}
      compName="OPEN Setup Information"
      permission={CanUserAccessOPENSetup()}
    >
      <Grid container justify="center" spacing={4}>
        <Grid item xs={5}>
          <RenderControl
            isLoading={isloadingOPENSetup}
            iserror={iserrorOPENSetup}
            compName="OPEN Configuration"
            permission={CanUserViewOPENSetupConfig()}
          >
            <OpenSetupConfigs
              isDisableEditButton={isDisableEditButton}
              data={openSetupInfo.openConfig}
              saveConfig={onSetOpenSetupConfig}
              protocolNumber={protocolNumber}
              protocolId={protocolId}
            />
          </RenderControl>
        </Grid>
        <Grid item xs={7}>
          <RenderControl
            isLoading={isloadingOPENSetup}
            iserror={iserrorOPENSetup}
            compName="OPEN Investigators"
            permission
          >
            <OpenInves openProtPerTypes={openProtPerTypes} />
          </RenderControl>
        </Grid>
        <Grid item xs={12}>
          <RenderControl
            isLoading={isloadingOPENSetup}
            iserror={iserrorOPENSetup}
            compName="Registration Steps"
            permission={CanUserViewOPENSteps()}
          >
            <RegSteps
              setIsDisableEditButton={setIsDisableEditButton}
              protocolNumber={protocolNumber}
              protocolId={protocolId}
              onSave={onSaveRegSteps}
              data={protocolLogistics}
              onRowClicked={ClickedRow}
              editPermission={CanUserEditOPENSteps()}
              deletePermission={CanUserDelOPENSteps()}
            />
          </RenderControl>
        </Grid>
        <Grid item xs={6}>
          <RenderControl
            isLoading={isloadingOPENSetup}
            iserror={iserrorOPENSetup}
            compName="OPEN IRTF Provider Setup"
            permission={CanUserViewOPENProvider()}
          >
            <OPENITRFProvideSetup
              data={protocolLogistics
                && protocolLogistics[regStepInd]
                && protocolLogistics[regStepInd].protStepRtfSetups}
              prlId={protocolLogistics
                && protocolLogistics[regStepInd]
                && protocolLogistics[regStepInd].prlId}
              psrs={psrs}
              onSave={onSaveIRTFProviderSetup}
              permission={CanUserEditOPENProvider()}
              selectedLogistics={protocolLogistics?.[regStepInd]}
            />
          </RenderControl>
        </Grid>
        <Grid item xs={6}>
          <RenderControl
            isLoading={isloadingOPENSetup}
            iserror={iserrorOPENSetup}
            compName="Miscellaneous"
            permission={CanUserViewOPENProvider()}
          >
            <Miscellaneous
              protocolId={protocolId}
              miscellaneous={openSetupInfo.miscellaneous}
              permission={CanUserEditMisc()}
            />
          </RenderControl>
        </Grid>
        <Grid item xs={12}>
          <RenderControl
            isLoading={isloadingOPENSetup}
            iserror={iserrorOPENSetup}
            compName="LPO OPEN Person Types"
            permission={CanUserViewOPENPerson()}
          >
            <GroupOpenPerson
              protocolId={protocolId}
              onSave={onSaveOpenSetupPersonTypes}
              data={openSetupInfo.protPerTypes}
              deletePermission={CanUserDelOPENPerson()}
              editPermission={CanUserEditOPENPerson()}
            />
          </RenderControl>
        </Grid>
        <Grid item xs={12}>
          <RenderControl
            isLoading={isloadingRelation}
            iserror={iserrorRelation}
            compName="Protocol Relations"
            permission={CanUserViewOPENRelations()}
          >
            <div
              className={CanUserEditOPENRelations() === true
                ? 'card-action-area__highlighted'
                : ''}
            >
              <ProtocolRelations
                data={relations}
                protocolNumber={protocolNumber}
                permission={CanUserEditOPENRelations()}
              />
            </div>
          </RenderControl>
        </Grid>
      </Grid>
    </RenderControl>
  );
};

const withConnectState = connect(
  (state, ownProps) => ({
    psrs: state.psrs.psrInfo.data,
    protocolNumber: ProtocolNumSelector(state),
    protocolId: ProtocolIdSelector(state),
    openSetupInfo: state.openData.openData,
    regStepInd: state.openData.regStepindex,
    relations: state.openData.relations,
    embedded: state.openData.embedded,
    isloadingOPENSetup: lOPENSetupSelector(state),
    iserrorOPENSetup: eOPENSetupSelector(state),
    isloadingRelation: lRelationSelector(state),
    iserrorRelation: eRelationSelector(state),
    isLoadingPrtDetails: lSelectorGetProtDetails(state),
    iserrorPrtDetails: eSelectorGetProtDetails(state)
  }),
  dispatch => bindActionCreators(
    {
      onGetOpenSetupData: getOpenSetup,
      onSetOpenSetupConfig: setOpenSetupConfig,
      onSaveRegSteps: saveRegistrationSteps,
      onSaveOpenSetupPersonTypes: saveOpenPersonTypes,
      onSetRegStepIndex: setRegStepIndex,
      onSaveIRTFProviderSetup: saveIRTFProviderSetup,
      onGetPsr: getPsrs,
      onGetRelations: getRelations
    },
    dispatch
  )
);

const OpenContainer = compose(
  withAppContext,
  withConnectState
)(OpenSetupComp);

export default OpenContainer;
